/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pushtask.vue?vue&type=template&id=27340b66&scoped=true"
import script from "./pushtask.vue?vue&type=script&lang=js"
export * from "./pushtask.vue?vue&type=script&lang=js"
import style0 from "./pushtask.vue?vue&type=style&index=0&id=27340b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27340b66",
  null
  
)

export default component.exports